import { toastMessageActions } from "../state/request";
import { useDispatch } from "react-redux";

function useAlert() {
  const dispatch = useDispatch();

  const setSuccess = (message: string) => {
    dispatch(toastMessageActions.setGlobalAlert({
      severity: "success",
      message,
    }));
  };

  const clearAlerts = () => {
    dispatch(toastMessageActions.resetGlobalAlert());
  };

  return {
    setSuccess,
    clearAlerts,
  };
}

export default useAlert;
